import makeStyles from '@mui/styles/makeStyles';
import {isOneToOne} from "business/matching";
import {isMentor} from "business/role";
import MatchSummary from "components/Matching/MatchSummary";
import {map, noop} from "lodash";
import React from "react";

const useStyles = makeStyles({
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
});

const MatchSummaries = ({
  matches = [],
  role,
  userMatchType,
  expiryHours,
  onUpdateMatch = noop,
  ...cardProps
}) => {
  const classes = useStyles();

  return (
    <div className={classes.list}>
      {map(matches, (match, index) => (
        <MatchSummary
          key={match.id || index}
          match={match}
          expiryHours={expiryHours}
          onUpdateMatch={interestStatus =>
            onUpdateMatch(match, interestStatus, isMentor(role), isOneToOne(userMatchType))}
          {...cardProps}/>
      ))}
    </div>
  );
};

export default MatchSummaries;
